const ProfileStateInterface = {
  loading: true,
  profileDetails: {},
  partnerDetails: {},
  errors: {
    error: false,
  },
  env: 'dev',
  textToTranslate: [],
};
module.exports = {
  ProfileStateInterface,
};
